import * as React from 'react'
import clsx from 'clsx'
import { useEnhancedEffect } from '@applift/factor'
import { useGridApiContext } from '../../hooks/utils/useGridApiContext'
import { useGridRootProps } from '../../hooks/utils/useGridRootProps'
import { getMinimalContentHeight } from '../../hooks/features/rows/gridRowsUtils'
import style from '../../style'

function GridOverlayWrapper(props: React.PropsWithChildren<{}>) {
  const apiRef = useGridApiContext()
  const rootProps = useGridRootProps()

  const [viewportInnerSize, setViewportInnerSize] = React.useState(
    () => apiRef.current.getRootDimensions()?.viewportInnerSize ?? null
  )

  const handleViewportSizeChange = React.useCallback(() => {
    setViewportInnerSize(
      apiRef.current.getRootDimensions()?.viewportInnerSize ?? null
    )
  }, [apiRef])

  useEnhancedEffect(() => {
    return apiRef.current.subscribeEvent(
      'viewportInnerSizeChange',
      handleViewportSizeChange
    )
  }, [apiRef, handleViewportSizeChange])

  let height: React.CSSProperties['height'] = viewportInnerSize?.height ?? 0
  if (rootProps.autoHeight && height === 0) {
    height = getMinimalContentHeight(apiRef) // Give room to show the overlay when there no rows.
  }

  if (!viewportInnerSize) {
    return null
  }

  return (
    <div
      className={clsx(style.overlayWrapper, rootProps.classes?.overlayWrapper)}
    >
      <div
        className={clsx(
          style.overlayWrapperInner,
          rootProps.classes?.overlayWrapperInner
        )}
        style={{
          height,
          width: viewportInnerSize?.width ?? 0,
        }}
        {...props}
      />
    </div>
  )
}

export function GridOverlays() {
  //  const apiRef = useGridApiContext()
  const rootProps = useGridRootProps()

  let overlay: JSX.Element | null = null

  if (rootProps.overlay === 'noRows') {
    overlay = (
      <rootProps.components.NoRowsOverlay
        {...rootProps.componentsProps?.noRowsOverlay}
      />
    )
  }

  if (rootProps.overlay === 'noResult') {
    overlay = (
      <rootProps.components.NoResultsOverlay
        {...rootProps.componentsProps?.noResultsOverlay}
      />
    )
  }

  if (rootProps.overlay === 'error') {
    overlay = (
      <rootProps.components.ErrorOverlay
        {...rootProps.componentsProps?.errorOverlay}
      />
    )
  }

  if (overlay === null) {
    return null
  }

  return <GridOverlayWrapper>{overlay}</GridOverlayWrapper>
}
